import { Expose } from 'class-transformer';

export class EvaluationType {
  @Expose()
  item: number;

  @Expose()
  description: string;
}
